import angular from 'angular';
import config from 'app/config';

import initBind from './initbind/initbind.directive';
import loadScript from './loadscript/loadscript.directive';
import addToCalendar from './addtocalendar/addtocalendar.directive';

export default angular
  .module(`${config.appName}.commonDirectives`, [
    initBind,
    loadScript,
    addToCalendar,
  ])
  .name;
